
<template>
    <a-select show-search v-model="currentCode" placeholder="选择平台类型" allow-clear style="width: 150px"
            :default-active-first-option="true" :filter-option="true" :not-found-content="null"
            @change="handleChange">
        <a-select-option v-for="d in data" :key="d.value">
            {{ d.text }}
        </a-select-option>
    </a-select>
</template>
<script>
export default {
    data() {
        return {
            data: [],
            currentCode:'',
            result:{
                platformcode:'',
                platformname:'',
                platformlist:[]
            }
        }
    },
    props:{
        platformcode:String
    },
    methods: {
        handleChange(v) {
            let target = this.data.filter(item => { return item.value == v });
            if(target.length > 0){
                this.result.platformcode = target[0].value;
                this.result.platformname = target[0].text;
                this.result.platformlist = this.data;
                this.$emit("platformChange", this.result);
            }
        },
        doSearch() {
            let that = this;
            let c_params = {
                urlparams: false,
            }

            that.$store.dispatch({
                type: "cloudconfig/queryplatform",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    let result = res.data.data;
                    if(!result){
                        that.message.error("未查询到平台");
                        return;
                    }
                    result.forEach(r => {
                        that.data.push({
                            value: r.platformcode,
                            text: r.platformname,
                        });
                    });
                    let target = that.data.filter(item => { return item.value == that.platformcode })

                    if(that.platformcode && target.length > 0){
                        that.currentCode = target[0].value;
                        that.result.platformcode = target[0].value;
                        that.result.platformname = target[0].text;
                    }
                    else{
                        that.currentCode = that.data[0].value
                        that.result.platformcode = that.data[0].value;
                        that.result.platformname = that.data[0].text;
                    }
                    
                    that.result.platformlist = that.data;
                    that.$emit("platformChange", that.result);
                }
            })
        },
    },
    mounted(){
        this.doSearch()
    }
   
};
</script>

<style scoped>

</style>
